import { useState, useEffect } from "react"

import ReactLoading from "react-loading"


// Routing
import { Routes, Route, useNavigate, useLocation, useSearchParams } from "react-router-dom";

// Layouts
import Layout from "./layouts/Layout";

// Routes
import IndexPage from "./pages";


// Other routes
import UnsubscribePage from "./pages/unsubscribe";
import Custom404 from "./pages/404";



// CSS
import "./App.css";

// Client environment
import { browserName, isMobile, isDesktop } from "react-device-detect";




const App = () => {

  // Navigate
  const navigate = useNavigate()

  // Location 
  const location = useLocation();

  // Search params
  const [search_params, set_search_params] = useSearchParams()
  const param_journey = search_params.get("journey")



  
  // States
  const [coordinator, set_coordinator] = useState("vivian");
  const [demo_modal_is_open, set_demo_modal_is_open] = useState(false)

  const [user_data, set_user_data] = useState({
    first_name: "",
    last_name: "",
    email_address: "",
    organization_name: "",
    position: "",
  });



  // // Upon load
  // useEffect(() => {

  //   // Handle anchor tag upon refresh, if any
  //   scroll_to_anchor_tag_upon_refresh(location)
    
  // }, [location])

  return (
    <>
      {/* Routes */}
      <Routes>
        <Route element={
          <Layout 

           
          />
        }>
          <Route 
            path="/" 
            element={
              <IndexPage 
              
              />
            } 
          />

          {/* <Route 
            path="demo" 
            element={
              <DemoPage 
                coordinator={coordinator}
                set_coordinator={set_coordinator}

                user_data={user_data}
                set_user_data={set_user_data}

                demo_is_active={demo_is_active}
                set_demo_is_active={set_demo_is_active}

                set_demo_modal_is_open={set_demo_modal_is_open}

                journey={journey}
              />
            } 
          /> */}


        </Route>

        <Route path="unsubscribe" element={<UnsubscribePage />} />
        <Route path="*" element={<Custom404 />} />
      </Routes>

    </>
  );
}

export default App;
